/**
 * Copyright (c) 2024 Spazious, Inc All Rights Reserved
 * Proprietary and confidential
 *
 * Written by Rubeniskov <ruben.lopez@spazious.com>, Fri Feb 16 2024
 */

import { Vector4Like } from 'three';

/**
 * Type guard for Vector4Like
 */
export const isVector4Like = (p: any): p is Vector4Like =>
  p?.isVector4 ||
  (typeof p?.x === 'number' &&
    typeof p?.y === 'number' &&
    typeof p?.z === 'number' &&
    typeof p?.w === 'number');
